import { Controller } from "@hotwired/stimulus"

const METRIKA_COUNTER_ID = 108142028

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 },
    goalKey: String,
    metrikaGoal: String,
    redirectUrl: String
  }

  connect() {
    this.reachGoal()
    this.redirectTimeout = window.setTimeout(() => {
      this.redirect()
    }, this.delayValue)
  }

  disconnect() {
    if (this.redirectTimeout) {
      window.clearTimeout(this.redirectTimeout)
    }
  }

  redirect() {
    if (!this.hasRedirectUrlValue) return

    window.location.assign(this.redirectUrlValue)
  }

  reachGoal() {
    if (!this.hasMetrikaGoalValue) return
    if (this.goalAlreadyReached()) return
    if (typeof window.ym !== "function") return

    window.ym(METRIKA_COUNTER_ID, "reachGoal", this.metrikaGoalValue)
    this.persistGoalReached()
  }

  goalAlreadyReached() {
    if (!this.hasGoalKeyValue) return false

    return window.sessionStorage.getItem(this.goalKeyValue) === "1"
  }

  persistGoalReached() {
    if (!this.hasGoalKeyValue) return

    window.sessionStorage.setItem(this.goalKeyValue, "1")
  }
}
